// tipo-acceso.service.ts

import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

export interface AppBaseUrls {
  primary: string;
  secondary: string;
  tertiary: string;
  quaternary: string;
}

@Injectable({
  providedIn: 'root'
})
export class TipoAccesoService {

  private appBaseUrls: AppBaseUrls;

  constructor() {
    this.appBaseUrls = environment.appBaseUrls;
  }

  /**
   * Obtiene todas las URLs base disponibles de la aplicación
   */
  getAppBaseUrls(): AppBaseUrls {
    return this.appBaseUrls;
  }

  /**
   * Obtiene la URL base primaria de la aplicación
   */
  getPrimaryBaseUrl(): string {
    return this.appBaseUrls.primary;
  }

  /**
   * Obtiene la URL base secundaria de la aplicación
   */
  getSecondaryBaseUrl(): string {
    return this.appBaseUrls.secondary;
  }

  /**
   * Obtiene la URL base terciaria de la aplicación
   */
  getTertiaryBaseUrl(): string {
    return this.appBaseUrls.tertiary;
  }

  /**
   * Obtiene la URL base cuaternaria de la aplicación
   */
  getQuaternaryBaseUrl(): string {
    return this.appBaseUrls.quaternary;
  }

  /**
   * Obtiene la URL base actual detectando desde window.location.origin
   */
  getCurrentBaseUrl(): string {
    const currentOrigin = window.location.origin + '/';
    const allUrls = Object.values(this.appBaseUrls);

    // Intentar encontrar la URL actual en las configuradas
    const matchedUrl = allUrls.find(url =>
      url.toLowerCase().includes(this.extractDomain(currentOrigin))
    );

    return matchedUrl || this.appBaseUrls.primary;
  }

  /**
   * Extrae el dominio de una URL
   */
  private extractDomain(url: string): string {
    try {
      const urlObj = new URL(url);
      return urlObj.hostname;
    } catch {
      return url;
    }
  }

  /**
   * Valida si una URL es una URL base configurada de la aplicación
   */
  isValidAppUrl(url: string): boolean {
    const allUrls = Object.values(this.appBaseUrls);
    return allUrls.some(baseUrl =>
      url.toLowerCase().startsWith(baseUrl.toLowerCase())
    );
  }

  /**
   * Obtiene la clave del tipo de entorno (primary, secondary, tertiary, quaternary)
   * basado en la URL actual detectada desde window.location.origin
   */
  getTipoEntorno(): string {
    const currentOrigin = window.location.origin + '/';
    const currentDomain = this.extractDomain(currentOrigin);
    console.log('Current domain:', currentDomain);
    console.log('App base URLs:', this.appBaseUrls);
    // Buscar la clave que corresponde a la URL actual
    for (const [key, value] of Object.entries(this.appBaseUrls)) {
      if (value.toLowerCase() == `https://${currentDomain}/`) {
        return key;
      }
    }

    // Si no encuentra coincidencia, devuelve 'primary' por defecto
    return 'primary';
  }

  isCompanyEnvironment(): boolean {

    return this.getTipoEntorno() === 'quaternary';
  }
}
